import React, { useEffect } from "react";
import Img1 from "./img/1.webp"; 
import Img2 from "./img/Mur tendu imprimé design avec motifs de feuilles artistiques dans un salon contemporain – solution décorative Unik System.webp"; 

import AOS from "aos";
import "aos/dist/aos.css";

const USArtDecoSection = () => {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  return (
    <div className="usstretch-section">

      {/* ===== BLOC US WALLDRESS ===== */}
      <div className="usstretch-row">

        <div className="usstretch-text">
          <h3 data-aos="fade-up-right">
            <span className="subtitle-us">US</span> WALLDRESS
          </h3><br/>

          <h5 data-aos="fade-up">Habillage mural décoratif</h5>

          <p data-aos="fade-up">
            Solutions d’habillage mural modernes permettant de transformer vos espaces 
            grâce à des textures innovantes, des effets 3D et des finitions haut de gamme.
          </p>

          <h6 data-aos="fade-up">Avantages :</h6>
          <ul data-aos="fade-up">
            <li>🎨 Design élégant et personnalisé</li>
            <li>🧱 Finitions haut de gamme</li>
            <li>✨ Effets décoratifs modernes (3D, textures)</li>
            <li>🏢 Adapté aux espaces résidentiels et professionnels</li>
            <li>⚡ Installation rapide et durable</li>
          </ul>

          <a
            data-aos="fade-up"
            href="/walldress-habillage-mural-maroc"
            className="learn-more-link"
          >
            En savoir plus <span className="arrow">→</span>
          </a>
        </div>

        <div
          className="usstretch-image"
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <img src={Img1} alt="US WallDress habillage mural décoratif" />
        </div>
      </div>

      {/* ===== BLOC US ARTFLOW ===== */}
      <div className="usstretch-row">

        <div
          className="usstretch-image"
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <img src={Img2} alt="US ArtFlow design artistique" />
        </div>

        <div className="usstretch-text">
          <h3 data-aos="fade-right">
            <span className="subtitle-us">US</span> ARTFLOW
          </h3><br/>

          <h5 data-aos="fade-up">Design artistique fluide</h5>

          <p data-aos="fade-up">
            Créations artistiques aux formes organiques et lignes modernes, 
            apportant mouvement, élégance et identité unique à vos espaces.
          </p>

          <h6 data-aos="fade-up">Avantages :</h6>
          <ul data-aos="fade-up">
            <li>🎨 Design contemporain et innovant</li>
            <li>🌊 Formes fluides et dynamiques</li>
            <li>🏗️ Intégration architecturale harmonieuse</li>
            <li>✨ Personnalisation selon le projet</li>
            <li>🏢 Idéal pour espaces premium et commerciaux</li>
          </ul>

          <a
            data-aos="fade-up"
            href="/artflow-decoration-murale-maroc"
            className="learn-more-link"
          >
            En savoir plus <span className="arrow">→</span>
          </a>
        </div>

      </div>

    </div>
  );
};

export default USArtDecoSection;